import { CheckLg } from "react-bootstrap-icons";

const MIN_REFRESH_MS = 30 * 1000;
const STORAGE_PREFIX = "portal_report_cache_v1:";

export const PORTAL_REPORT_RESOURCES = {
  INCOMING_SUMMARY_LIST: "incoming-summary-list",
  INCOMING_SUMMARY_DATE_RANGE: "incoming-summary-date-range",
  INCOMING_SUMMARY_DASHBOARD: "incoming-summary-dashboard",
  OUTGOING_SUMMARY_DASHBOARD: "outgoing-summary-dashboard",
  INCOMING_REPORT_BY_DID: "incoming-report-by-did",
  INCOMING_REPORT_TRACE: "incoming-report-trace",
  INCOMING_REPORT_ABANDONED: "incoming-report-abandoned",
  INCOMING_REPORT_ABANDONED_RANGE: "incoming-report-abandoned-range",
  CDR_REPORT: "cdr-report",
  DOWNLOAD_REPORT_LIST: "download-report-list",
};

function stableStringify(value) {
  if (value === null || value === undefined) {
    return "null";
  }

  if (Array.isArray(value)) {
    return `[${value.map((item) => stableStringify(item)).join(",")}]`;
  }

  if (typeof value === "object") {
    return `{${Object.keys(value)
      .sort()
      .map((key) => `${JSON.stringify(key)}:${stableStringify(value[key])}`)
      .join(",")}}`;
  }

  return JSON.stringify(value);
}

function buildStorageKey(resource, userId, role, params = {}) {
  return `${STORAGE_PREFIX}${resource}:${userId}:${role}:${stableStringify(params)}`;
}

function readStoredEntry(key) {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) {
      return null;
    }

    return JSON.parse(raw);
  } catch {
    return null;
  }
}

function writeStoredEntry(key, data) {
  try {
    sessionStorage.setItem(
      key,
      JSON.stringify({
        fetchedAt: Date.now(),
        data,
      })
    );
  } catch {
    // Ignore storage quota or private-mode errors.
  }
}

export function getRemainingRefreshMs(resource, userId, role, params = {}) {
  const key = buildStorageKey(resource, userId, role, params);
  const entry = readStoredEntry(key);
  if (!entry?.fetchedAt) {
    return 0;
  }

  return Math.max(0, MIN_REFRESH_MS - (Date.now() - entry.fetchedAt));
}

export async function loadPortalReportData({
  resource,
  userId,
  role,
  params = {},
  fetchFn,
  force = false,
  onBlocked,
}) {

  console.log("came to fetch here ")

  if (userId == null || !role) {
    const data = await fetchFn();
    return {
      data,
      fromCache: false,
      blocked: false,
      remainingMs: 0,
    };
  }

  const key = buildStorageKey(resource, userId, role, params);

  console.log("Read storage from here", key)

  const entry = readStoredEntry(key); 

  console.log("Read key entry", entry)

  const remainingMs = entry?.fetchedAt
    ? Math.max(0, MIN_REFRESH_MS - (Date.now() - entry.fetchedAt))
    : 0;

  console.log("remaining mili seconds", remainingMs)

  if (entry && remainingMs > 0) {
    if (force) {
      onBlocked?.(remainingMs, entry.data);
    }
    return {
      data: entry.data,
      fromCache: true,
      blocked: Boolean(force),
      remainingMs,
    };
  }

  const data = await fetchFn();
  writeStoredEntry(key, data);
  return {
    data,
    fromCache: false,
    blocked: false,
    remainingMs: 0,
  };
}
